/** Bind payment links to their explicit chain before loading or submitting. */
export function paymentLinkNetworkError(
  search: string,
  chainId: number,
): string | null {
  const params = new URLSearchParams(search);
  const chains = params.getAll("chainId");
  if (chains.length !== 1 || !/^[1-9][0-9]{0,15}$/.test(chains[0]))
    return "This payment link is missing a valid network. Ask the recipient for a new link.";
  if (BigInt(chains[0]) !== BigInt(chainId))
    return "This payment link belongs to a different network. Open the original link from the recipient.";
  const networks: Record<string, number> = {
    "dogeos-chikyu": 6281971,
    "base-sepolia": 84532,
    base: 8453,
  };
  if (
    params.has("network") &&
    (params.getAll("network").length !== 1 ||
      networks[params.get("network")!] !== chainId)
  )
    return "This payment link belongs to a different network.";
  return null;
}
